/** Site + shop URLs — marketing site is React; commerce lives on the shop subdomain */

export const SITE_URL = 'https://ammachekku.com';
export const SHOP_URL = 'https://shop.ammachekku.com';

/** Fallback shop categories — used until / when API categories load */
export const shopCategoryList = [
  { id: 'groundnut', name: 'Groundnut Oils', slug: 'groundnut-oils' },
  { id: 'sesame', name: 'Sesame Oils', slug: 'sesame-oils' },
  { id: 'coconut', name: 'Coconut Oils', slug: 'coconut-oils' },
  { id: 'combo', name: 'Combo Packs', slug: 'combo-packs' },
];

export const shopCategoryUrl = (slug) => `${SHOP_URL}/category/${slug}`;
export const shopProductUrl = (slug) => `${SHOP_URL}/product/${slug}`;
export const shopSearchUrl = (query = '') => {
  const q = String(query || '').trim();
  if (!q) return `${SHOP_URL}/shop`;
  return `${SHOP_URL}/shop?search=${encodeURIComponent(q)}`;
};

export const productSlugs = {
  groundnut1L: 'cold-pressed-groundnut-oil-01l',
  coconut1L: 'cold-pressed-coconut-oil-01l',
  sesame1L: 'cold-pressed-sesame-oil-01l',
};

export const shop = {
  home: `${SHOP_URL}/`,
  cart: `${SHOP_URL}/cart`,
  account: `${SHOP_URL}/my-account`,
  login: `${SITE_URL}/log-in`,
  logout: `${SITE_URL}/`,
  search: `${SHOP_URL}/shop`,
  categories: Object.fromEntries(
    shopCategoryList.map((cat) => [cat.id, shopCategoryUrl(cat.slug)])
  ),
  products: {
    groundnut1L: shopProductUrl(productSlugs.groundnut1L),
    coconut1L: shopProductUrl(productSlugs.coconut1L),
    sesame1L: shopProductUrl(productSlugs.sesame1L),
  },
};

export const site = {
  home: '/',
  about: '/about',
  contact: '/contact',
  login: '/log-in',
  register: '/registration',
  policies: {
    terms: `${SHOP_URL}/terms-and-conditions`,
    privacy: `${SHOP_URL}/privacy-policy`,
    refund: `${SHOP_URL}/return-and-refund-policy`,
    shipping: `${SHOP_URL}/shipping-policy`,
  },
};
